export default "__VITE_ASSET__BVN95XpH__"